import { render, staticRenderFns } from "./Shinhan.vue?vue&type=template&id=44e54a90&scoped=true&"
import script from "./Shinhan.vue?vue&type=script&lang=js&"
export * from "./Shinhan.vue?vue&type=script&lang=js&"
import style0 from "./Shinhan.vue?vue&type=style&index=0&id=44e54a90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e54a90",
  null
  
)

export default component.exports